const generalConstants = {
  SIDER_TOGGLE: "SIDER_TOGGLE",
};

export default generalConstants;
